import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Label, SelectSearch, Text } from '@mercai/clever'

import { useAiReactiovationMetaTemplateList } from '@/services'

import { MetaTemplateStepProps } from './meta-template-step.type'

import { IAReactivationMetaTemplateProps } from '@/types'

import { WhatsAppText } from '@/components'

import styles from './meta-template-step.module.css'

import { VariableMapper } from './components'

export const MetaTemplateStep = ({
  onSelectMetaTemplate,
  selectedMetaTemplate,
  availableVariables,
  onMappingChange,
}: MetaTemplateStepProps) => {
  const { t } = useTranslation('screenAiCenter')
  const [search, setSearch] = useState('reactivation')
  const {
    data: reactivationMetaTemplateList,
    isLoading: isLoadingReactivationMetaTemplateList,
  } = useAiReactiovationMetaTemplateList({ name: search })

  const handleMappingChange = (mapping: Record<string, string>) => {
    onMappingChange(mapping)
  }

  const bodyText = selectedMetaTemplate?.components?.find(
    (component) => component.type === 'BODY',
  )?.text

  return (
    <div className={styles.core}>
      <div>
        <Label>{t('conversationNewTemplateLabel')}</Label>

        <SelectSearch<IAReactivationMetaTemplateProps>
          hasLabel={false}
          dataSearch={reactivationMetaTemplateList?.data || []}
          isLoadingSearch={isLoadingReactivationMetaTemplateList}
          onSearch={setSearch}
          initialSearch={search}
          onSelectItem={(item) =>
            onSelectMetaTemplate(item as IAReactivationMetaTemplateProps)
          }
          selectedItem={selectedMetaTemplate}
          renderContentItem={(item) => (
            <div className={styles.item}>
              <Text variant="title-base">{item.name}</Text>
              <Text variant="text-small">{item.category}</Text>
            </div>
          )}
          keyLabel="name"
          keyValue="id"
          translations={{
            inputSearchPlaceholder: t(
              'conversationNewTemplateInputSearchPlaceholder',
            ),
            noResults: t('conversationNewTemplateNoResults'),
            inputSearchLabel: t('conversationNewTemplateInputSearchLabel'),
          }}
        />
      </div>

      {bodyText && <WhatsAppText text={bodyText} />}

      <VariableMapper
        selectedMetaTemplate={selectedMetaTemplate}
        onMappingChange={handleMappingChange}
        availableVariables={availableVariables}
      />
    </div>
  )
}
